module.exports = __webpack_public_path__ + "static/media/pix-bc.954f31ba.png";